import { getWalletsList } from "@auer-steel/Services/WalletService";
import { addToChainAfter, addToChainBefore, ApiHandlerDiscreteParameter, HasOnError } from "@insite/client-framework/HandlerCreator";
import { Cart, CartResult, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import {
    chain,
    SetCreditCard
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/PlaceOrder";

addToChainAfter(chain, SetCreditCard, async function (props: any) {
    // B2BES [AST-689] - Only call getWalletsList() when payment method is ACH.
    if (props?.cartToUpdate?.paymentMethod?.isECheck === true) {
        const response = await getWalletsList();
        if (response.successful) {
            const wallets = response.result;
            if (wallets === undefined) {return;}
            const chosenWallet = wallets?.find(wallet => wallet.PaymentProfileId === props.parameter.achAccountId);
            props.parameter.accountNumber = chosenWallet?.PaymentProfileId;
            props.parameter.routingNumber = chosenWallet?.CardType;
            props.parameter.accountHolderName = "Logged-in user";
        }
    }
});
